module.exports = __webpack_public_path__ + "img/Products.6938f3fc.svg";